//import Player from '@vimeo/player';

export class ScrChecker {
    constructor() {
        this.inviewElems = []; //inviewで効果をつける要素を登録する

        this.windowWidth = 0;
        this.windowWidthThen = 0;


        // Corporate Movie モーダルウインドウ (Jstream)
        this.playerMain = {};
        this.initMainMovFlg = false; //初回表示

        // Corporate Bg Loop Movie (Jstream)
        this.bgMovPc = "OTIy"; //PC
        this.bgMovSp = "OTIz"; //SP
        this.playerPc = {}; //PC
        this.playerSp = {}; //SP jstreamはplayerにあとからloadできない?
        this.playerReadyPc = false;
        this.playerReadySp = false;

        // Corporate Bg Loop Movieの再生中Flg
        //this.movLoopPlay = true; //false;

        // モーダルウインドウ　Close Btn
        this.corpMovBtn = {};
        this.openModalFlg = false;


    }
    setProps(el, props) {
        for (let key in props) {
            el.style.setProperty('--' + key, props[key]);
        }
    };
    clamp(v, min, max) {
        return min > v ? min : max < v ? max : v;
    }
    round(n) {
        return Math.round(n * 10000) / 10000;
    }

    calcElementOffsetY(elem) {
        let container = window;

        let parentElem;
        if (elem.parentElement) {
            parentElem = elem.parentElement;
        }
        let target = parentElem;

        // ページ全体に対するY座標を計算
        let numY = 0;
        do {
            numY += target.offsetTop; //target.offsetTop;はノードの上端に対しての現在の要素の距離
            target = target.offsetParent;
            //console.log(target);
        } while (target && target !== container); //要素のcontainerに対するY座標

        return numY;
    }


    onUpdate() {
        this.body = document.getElementsByTagName('body')[0];
        this.html = document.getElementsByTagName('html')[0];
        let windowLeft = (window.screenLeft || window.screenX || 0);
        let windowTop = (window.screenTop || window.screenY || 0);
        let windowWidth = (window.innerWidth || document.documentElement.clientWidth || 0);
        let windowHeight = (window.innerHeight || document.documentElement.clientHeight || 0);
        let windowScrollY = window.scrollY || window.pageYOffset;
        let windowScrollX = window.scrollX || window.pageXOffset;


        // 汎用
        if (windowScrollY > windowHeight) {
            this.body.classList.add('scrolled-windowheight');
        } else {
            this.body.classList.remove('scrolled-windowheight');
        }

        if (windowScrollY > windowHeight * 0.8) {
            this.body.classList.add('scrolled-show-index-pager');
        } else {
            this.body.classList.remove('scrolled-show-index-pager');
        }
        if (this.body.classList.contains('index')) {
            //this.body.classList.remove('scrolled-title');
        } else {
            if (windowScrollY > 200) {
                this.body.classList.add('scrolled-title');
            } else {
                this.body.classList.remove('scrolled-title');
            }
        }


        // ==============
        // 動画 Bg loop
        if (document.getElementById('js-video-jstream-loop')) {
            let elem = document.getElementById('js-video-jstream-loop');
            let elemHeight = elem.clientHeight;
            let elemY = windowScrollY + elem.getBoundingClientRect().top;
            if (windowScrollY > (elemY + elemHeight)) {
                this.playerPc.accessor.pause();
                this.playerSp.accessor.pause();
                //this.player.pause();
                //console.log('js-index-movie-loop pause');
            } else {
                // if (this.movLoopPlay && this.playerReadyPc) {
                //     //this.playerPc.accessor.play();
                //     //this.playerSp.accessor.play();
                //     //this.player.play();
                // }
            }
        }


        // ===========
        // #index-visionrd
        if (document.getElementById('index-visionrd')) {
            let elem = document.getElementById('index-visionrd');
            let elemHeight = elem.clientHeight;
            let clientRect = elem.getBoundingClientRect();
            let elemY = windowScrollY + clientRect.top; // ページの上端から、要素の上端までの距離

            // アニメーション位置
            let animStartY = Math.floor(elemY);
            //let animEndY = Math.floor(elemY + elemHeight);
            let animEndHeight = Math.floor(elemHeight);
            let animNowY = Math.floor(windowScrollY + windowHeight);
            let animPer1 = this.clamp(1.8 * ((animNowY - (animStartY + 150)) / animEndHeight), 0, 1);
            let animPer2 = this.clamp(1.0 * ((animNowY - animStartY) / (animEndHeight + 140)), 0, 1);
            //console.log(animStartY, animNowY, animPer, animEndY);
        }



        // ===========
        // inview判定

        this.inviewElems = document.querySelectorAll('.js-inview');
        //.js-anim-inview に .inview 追加
        if (this.inviewElems.length !== 0) {
            //inviewElems = document.querySelectorAll('.js-inview');//複数
            [].forEach.call(this.inviewElems, (elem) => {
                //console.log(elem.classList);
                let clientRect = elem.getBoundingClientRect(); // 要素の位置座標
                let y = clientRect.top; //画面の上端から、要素の上端までの距離
                //let elemY = windowScrollY + clientRect.top;// ページの上端から、要素の上端までの距離

                //表示タイミング ウインドウ上端から
                let showPos = windowHeight * 0.5;
                if (windowWidth > 600) {
                    showPos = windowHeight * 0.6; //pc
                }

                if (showPos > y) {
                    if (this.body.classList.contains('loaded')) {
                        elem.classList.add('inview');
                        // let timerInviewAfter = setTimeout( () => {
                        //     elem.classList.add('inview');
                        // }, 1000);
                    } else {
                        elem.classList.add('inview');
                    }
                }
            });
        }

    }


    initMov() {
        //console.log('scroll-checker.initMov');

        // Jstream Player ------
        this.playerSp = window.jstream_t3.PlayerFactoryIF.create({
            b: "eqa940luwj.eq.webcdn.stream.ne.jp/www50/eqa940luwj/jmc_pub/jmc_swf/player/",
            c: "MTMxNQ==",
            m: this.bgMovSp,
            s: {
                dq: 4, //Default Quality
                mdq: 4, //Mobile Quality
                hp: 720,
                il: "off",
                rp: "fit", //Responsive
                lu: "on", //loop_use
                pr: "0.5,0.7,1.2,1.5,2.0",
                pb: "off", //Play Button
                sn: "",
                tg: "off",
                ti: "off", //Title
                wp: 980,
                wm: "off", //Water Mark 中央再生ボタンの表示有無
                vc: "off", //Volume Control
                sb: "off", //Seek Bar
                fs: "off", //Full Screen
                cp: "off", //Control panel
                is: "off", //Init Sound
                ip: "on" //Init Play 自動再生ON(ip:"on")にしたときにiOSでは自動的にミュート状態に切り替わります https://support.eq.stream.co.jp/hc/ja/articles/115009580027-%E9%85%8D%E4%BF%A1%E6%96%B9%E5%BC%8F
            },
        }, "js-video-jstream-loop-sp");

        this.playerPc = window.jstream_t3.PlayerFactoryIF.create({
            b: "eqa940luwj.eq.webcdn.stream.ne.jp/www50/eqa940luwj/jmc_pub/jmc_swf/player/",
            c: "MTMxNQ==",
            m: this.bgMovPc,
            s: {
                dq: 4, //Default Quality
                mdq: 4, //Mobile Quality
                hp: 360,
                il: "off",
                rp: "fit", //Responsive
                lu: "on", //loop_use
                pr: "0.5,0.7,1.2,1.5,2.0",
                pb: "off", //Play Button
                sn: "",
                tg: "off",
                ti: "off", //Title
                wp: 640,
                wm: "off", //Water Mark 中央再生ボタンの表示有無
                vc: "off", //Volume Control
                sb: "off", //Seek Bar
                fs: "off", //Full Screen
                cp: "off", //Control panel
                is: "off", //Init Sound
                ip: "on" //Init Play 自動再生ON(ip:"on")にしたときにiOSでは自動的にミュート状態に切り替わります https://support.eq.stream.co.jp/hc/ja/articles/115009580027-%E9%85%8D%E4%BF%A1%E6%96%B9%E5%BC%8F
            },
        }, "js-video-jstream-loop");

        console.log(this.playerPc.accessor);
        console.log(this.playerSp.accessor);
        //console.log('/scroll-checker.initMov');


        this.playerPc.accessor.addEventListener("landing", () => {
            this.playerReadyPc = true;
            //console.log('playerReadyPc');
            // if (window.innerWidth <= 768) {
            //     console.log('playerReadyPc pause');
            //     this.playerPc.accessor.pause();
            // }

            window.setTimeout(() => {
                this.onResizeMov();
            }, 800);
        });
        this.playerSp.accessor.addEventListener("landing", () => {
            this.playerReadySp = true;
            //console.log('playerReadySp');
            // if (window.innerWidth > 768) {
            //     console.log('playerReadySp pause');
            //     this.playerSp.accessor.pause();
            // }
            window.setTimeout(() => {
                this.onResizeMov();
            }, 800);
        });
        //this.onResizeMov();


        //popup
        this.corpMovBtn = document.querySelector('.index-movie__controller');
        this.corpMovBtn.addEventListener('click', (event) => {
            event.preventDefault();
            this.showMainMovModal();
            console.log('clicked!!');
        });

    }

    showMainMovModal() {
        // Corporate Movie モーダルウインドウ内
        let modal = document.getElementById('js-video-jstream-container-1');
        if (!this.initMainMovFlg) {
            // Jstream Player 
            this.playerMain = window.jstream_t3.PlayerFactoryIF.create({
                b: "eqa940luwj.eq.webcdn.stream.ne.jp/www50/eqa940luwj/jmc_pub/jmc_swf/player/",
                c: "MTMxNQ==",
                m: "ODA4",
                s: {

                    dq: "5",
                    mdq: "2",
                    pr: "0.5,0.7,1.2,1.5,2.0",

                    cc: "off",
                    el: "off",
                    hp: 1080,
                    il: "off",
                    mb: "off",
                    rp: "fit",
                    sn: "",
                    tg: "off",
                    ti: "off",
                    wp: 1920,
                    is: "on",
                    ip: "off" //iOS 自動再生ON(ip:”on”)にしたときに自動的にミュート状態に切り替わります https://support.eq.stream.co.jp/hc/ja/articles/115009580027-%E9%85%8D%E4%BF%A1%E6%96%B9%E5%BC%8F
                },
            }, "js-video-jstream-1");

            //close btn
            let btn = modal.querySelector('.jstream__close-btn');
            btn.addEventListener('click', (event) => {
                //console.log('cewfcewfe');
                this.playerMain.accessor.pause();
                event.preventDefault();
                this.hideMainMovModal();
            });
        }


        this.body.classList.add('is-modal-show');
        modal.classList.add('is-show');

        this.initMainMovFlg = true;
        this.openModalFlg = true;

        this.onResizeMov();
    }

    hideMainMovModal() {
        this.body.classList.remove('is-modal-show');
        document.getElementById('js-video-jstream-container-1').classList.remove('is-show');
        //this.playerPc.accessor.play();
        //this.playerSp.accessor.play();
        //this.player.play();
        // this.movLoopPlay = true;
        this.openModalFlg = false;
        this.onResizeMov();
    }



    onResizeMov() {
        //console.log('onResizeMov');
        // checkBgMovSizeAndPlay
        // Jstream ウインドウサイズチェック + SP/PCのどちらを表示するかチェック + 再生すべきかチェック
        this.windowWidth = window.innerWidth; //document.documentElement.clientWidth;
        if (this.windowWidth > 1000) {
            //PC
            document.getElementById('js-video-jstream-loop').classList.remove('hide');
            document.getElementById('js-video-jstream-loop-sp').classList.add('hide');
            if (this.openModalFlg) {
                //モーダルウインドウ オープン時
                this.playerSp.accessor.pause();
                this.playerPc.accessor.pause();
            } else {
                //モーダルウインドウが閉じている
                //console.log(this.playerReadyPc);
                this.playerSp.accessor.pause();
                if (this.playerReadyPc) {
                    this.playerPc.accessor.play();
                }
            }
        } else {
            //SP
            document.getElementById('js-video-jstream-loop').classList.add('hide');
            document.getElementById('js-video-jstream-loop-sp').classList.remove('hide');
            if (this.openModalFlg) {
                //モーダルウインドウ オープン時
                this.playerSp.accessor.pause();
                this.playerPc.accessor.pause();
            } else {
                //モーダルウインドウが閉じている
                //console.log(this.playerReadySp);
                this.playerPc.accessor.pause();
                if (this.playerReadySp) {
                    this.playerSp.accessor.play();
                }
            }
        }
        // console.log('onResizeMov');
    }

    // getMovId() {
    //     this.windowWidth = document.documentElement.clientWidth;
    //     this.windowHeight = document.documentElement.clientHeight;
    //     //this.windowInnerWidth = window.innerWidth; //ツールバーを除く
    //     //this.windowInnerHeight = window.innerHeight; //ツールバーを除く

    //     //画面の縦横比をチェック、再生する動画のIDを返す
    //     let returnStr = "";
    //     let bgMovId;
    //     let ratio = this.windowWidth / this.windowHeight;

    //     if (ratio > 1) {
    //         bgMovId = this.bgMovPc;
    //     } else {
    //         bgMovId = this.bgMovSp;
    //     }
    //     return bgMovId;
    // }


    // 初期化
    init() {
        this.windowWidthThen = window.innerWidth;
        // console.log('scrChecker.init');

        // #js-index-movie-loop
        if (document.getElementById('js-video-jstream-loop')) { //js-index-movie-loop
            //let videoElem = document.getElementById('js-index-movie-loop');
            this.initMov();
        }
    }
}